module.exports = __webpack_public_path__ + "img/servicioCondDesignado.284fe07e.jpg";